export const clearLoader = () => {
    const loader = document.querySelector('.static-loader');
    if (loader) {
        loader.classList.add('fade-out');
    }
    setTimeout(() => {
        loader.remove();
    }, 900);
};
